<template>
    <div>
        <training-card
            v-for="training, index in webinars"
            :key="index"
            :title="training.title"
            :link="training.link"
            :date="training.date"
            :poster="training.poster"
        />
    </div>
</template>

<script>
    import { TrainingCard } from '../trainingCard';

    export default {
        name: 'webinars',
        props: {
            webinars: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        components: {
            TrainingCard,
        },
    }
</script>


// WEBPACK FOOTER //
// Webinars.vue?f68c1ac0